import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Directory from "./pages/Directory";
import Summary from "./pages/Summary";
import Strength from "./pages/Strength";
import Compliance from "./pages/Compliance";
import Pipeline from "./pages/Pipeline";
import Profile from "./pages/Profile";
import AddFaculty from "./pages/AddFaculty";
import BulkImport from "./pages/BulkImport";
import Inspection from "./pages/Inspection";
import Schema from "./pages/Schema";
import AccessRequests from "./pages/AccessRequests";
import AebasDiscrepancies from "./pages/AebasDiscrepancies";
import ProtectedShell from "./components/ProtectedShell";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: detect session_id during render (synchronous, before ProtectedShell auth check)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedShell />}>
        <Route path="/" element={<Directory />} />
        <Route path="/add" element={<AddFaculty />} />
        <Route path="/edit/:id" element={<AddFaculty />} />
        <Route path="/bulk-import" element={<BulkImport />} />
        <Route path="/summary" element={<Summary />} />
        <Route path="/strength" element={<Strength />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/pipeline" element={<Pipeline />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/inspection" element={<Inspection />} />
        <Route path="/schema" element={<Schema />} />
        <Route path="/access-requests" element={<AccessRequests />} />
        <Route path="/aebas-discrepancies" element={<AebasDiscrepancies />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
